<template>
	<div class="container mt-4">
		<h2><i class="bi bi-card-list me-2"></i> Activity Card</h2>
		<p class="text-muted">MapVision activity card review is coming soon.</p>
	</div>
</template>
